<template>
  <div
    v-if="supplier && supplier.hbt_flow_enabled"
    class="flex items-center mdsm:hidden"
  >
    <div v-if="!getSelectedRoomDetails.length" class="flex-1 text-right">
      <span>from</span>
      <span class="font-medium fs-24">
        <currency-context>
          <template v-slot="{ convert }">
            <span
              class="font-medium fs-24"
              v-text="convert(getTotalBooking || prePrice)"
            ></span>
          </template>
        </currency-context>
      </span>
      <span>/night</span>
    </div>
    <div v-else class="flex flex-col items-end">
      <span class="font-medium fs-24">
        <currency-context>
          <template v-slot="{ convert }">
            <span
              class="font-medium fs-24"
              v-text="convert(getTotalBooking || prePrice)"
            ></span>
          </template>
        </currency-context>
      </span>
      <span class="fs-14 text-black-light-5">{{ orderInfo() }} </span>
    </div>
    <div class="flex-none pl-4">
      <button
        type="button"
        class="btn btn-primary input-tall font-medium"
        :class="{
          'btn-outlined': getSelectedRoomDetails.length,
        }"
        @click="onClick(getSelectedRoomDetails.length > 0)"
      >
        {{ ctaText() }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  props: ["prePrice"],
  data() {
    return {
      supplier: null,
    };
  },
  mounted() {
    window.fetchSupplierInfo(this.resortId).then((response) => {
      this.supplier = response.supplier;
    });
  },
  computed: {
    ...mapState(["bookingRooms"]),
    ...mapGetters([
      "getSelectedRoomDetails",
      "travellersDisplay",
      "getTotalBooking",
    ]),
    unselectedGroups() {
      const selectedGroups = this.getSelectedRoomDetails.map((room) =>
        room.group.slice(5)
      );

      let results = [];
      for (let i = 1; i <= this.bookingRooms.length; i++) {
        if (!selectedGroups.includes(i.toString())) {
          results.push(i);
        }
      }
      return results;
    },
  },
  methods: {
    ctaText() {
      if (!this.getSelectedRoomDetails.length) {
        return "Choose your room";
      } else if (
        this.getSelectedRoomDetails.length === this.bookingRooms.length
      ) {
        return "View summary";
      } else {
        return `Select room ${this.unselectedGroups[0]}`;
      }
    },
    orderInfo() {
      return this.travellersDisplay({ withRoom: true, withNight: true });
    },
    onClick(value) {
      if (this.getSelectedRoomDetails.length === this.bookingRooms.length) {
        this.$store.commit("setShowPriceDetailsModal", value);
      }

      if (value === true) {
        window.scrollToElement($(".wrap-hbt-booking"));
      } else {
        window.scrollToElement($("h2#Rooms"));
      }
    },
  },
};
</script>
